import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { RegisterRequestToken } from '@sleed/bizcommerce-api';
import { registerRequestsApi } from '~/lib/api/client';
import { formToToken, type RegisterRequestFormValues } from '~/lib/schemas/register-request';

export const registerRequestKeys = {
	all: ['register-requests'] as const,
	list: () => [...registerRequestKeys.all, 'list'] as const
};

/** All register requests (client-side grid; the legacy admin loads the full set via GetAll). */
export function useRegisterRequestsList() {
	return useQuery<RegisterRequestToken[]>({
		queryKey: registerRequestKeys.list(),
		queryFn: async () => (await registerRequestsApi.getAll()).data.items ?? []
	});
}

export function useRegisterRequestMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: registerRequestKeys.all });
	const update = useMutation({
		mutationFn: async ({ form, original }: { form: RegisterRequestFormValues; original: RegisterRequestToken | null }) =>
			(await registerRequestsApi.update(formToToken(form, original))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({
		mutationFn: async (id: number) => (await registerRequestsApi.remove(id)).data,
		onSuccess: invalidate
	});
	return { update, remove };
}
